import HttpStatus from 'http-status-codes';
import { BaseError } from './base-error';

export class InvalidEmailError extends BaseError {
  constructor() {
    super(InvalidEmailError.name, HttpStatus.BAD_REQUEST, 'GLOBAL.InvalidEmail', true);
  }
}
